import script from "/app/pages/RegisterUser.vue?type=script";
import { render } from "/app/pages/RegisterUser.vue?type=template";
script.render = render;
export default script;
